var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantCashFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2B74D8",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7917 19.1667L17.1042 14H13.7709L14.375 9.27082L10.5209 14.8333H13.4167L12.7917 19.1667ZM11.1475 21.8685L11.9809 16.0833H8.12671L14.9936 6.17145H16.0192L15.194 12.75H19.7771L12.1732 21.8685H11.1475Z",
    fill: "#2B74D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantCashFlow);
export default __webpack_public_path__ + "static/media/instant-cash-flow.a74767f796c45070fa7147185ea96b29.svg";
export { ForwardRef as ReactComponent };